import { Sprout } from 'lucide-react';

/**
 * Small "we're still building this community" note shown above the
 * results grid on the three discovery pages (events, instructors, play
 * locations). Honest framing — the site is young and there will be
 * thin areas, especially outside major metros. Always rendered (not
 * gated on auth state) so existing members feel like co-builders, not
 * just consumers.
 */
export function CommunityGrowthNote({ surface }) {
  const ctaByPage = {
    events: {
      action: 'Post an event',
      href: '/events/post',
      hint: 'Hosting a casual game? List it.',
    },
    instructors: {
      action: 'Become an instructor',
      href: '/register?role=instructor',
      hint: 'Teach? Set up your profile.',
    },
    'play-locations': {
      action: 'Suggest a location',
      href: '/play-locations/suggest',
      hint: 'Know a spot that should be here?',
    },
  };
  const cta = ctaByPage[surface] || ctaByPage.events;
  return (
    <div
      className="mb-4 p-3 rounded-2xl border border-[#56dfb4]/30 flex items-start gap-3"
      style={{ backgroundImage: 'linear-gradient(135deg, rgba(86,223,180,0.07), rgba(86,198,223,0.05), rgba(180,86,223,0.06))' }}
      data-testid={`community-growth-note-${surface}`}
    >
      <Sprout className="w-5 h-5 text-[#3ec49b] flex-shrink-0 mt-0.5" />
      <p className="text-sm text-slate-700 leading-relaxed">
        <span className="font-semibold">Meet For Mahjong is a young, growing community</span> — we're building it together. {cta.hint}{' '}
        <a href={cta.href} className="font-semibold text-[#b456df] hover:underline">{cta.action} &rarr;</a>
      </p>
    </div>
  );
}
